import { LabelMimeType } from '~/helpers/successHelpers'
import type { StepLink } from '~/helpers/successHelpers'
import type { LabelType } from '~/model'

const ReturnLabelsStorageKey = 'returnportal:returnLabels'

// if there are labels, temporarily persists them in sessionStorage
export const persistLabels = (labels: string[] | undefined) => {
  if (labels && labels.length > 0) {
    window?.sessionStorage.setItem(ReturnLabelsStorageKey, JSON.stringify(labels))
  }
}

export const encodedLabelToUri = (encodedLabel: string) => {
  const byteArray = Uint8Array.from(atob(encodedLabel), (char) => char.charCodeAt(0))
  const blob = new Blob([byteArray], { type: LabelMimeType })
  return URL.createObjectURL(blob)
}

const labelUriToStepLink = (link: string, index: number, labelType: LabelType = 'PrintedLabel'): StepLink => {
  // translation key
  const key =
    labelType === 'QrCode' ? `success.servicepoint.qrcode.step1_download` : `success.servicepoint.step1_download`

  return {
    key,
    link,
    download: true,
    dataTest: `download-label-url-${index + 1}`,
  }
}

/*
 * Grab the labels from sessionStorage, if available
 *
 * @param labelType the type of label we are looking for (QrCode or PrintedLabel). Defaults to 'PrintedLabel'.
 * @return [hasLabels, labels] hasLabels is true if there are labels in sessionStorage, labels is an array of StepLink objects
 */
export const getLabelLinks = (labelType: LabelType = 'PrintedLabel'): [boolean, StepLink[]] => {
  const encodedLabels = window?.sessionStorage.getItem(ReturnLabelsStorageKey)
  const hasLabels = !!encodedLabels

  return [
    hasLabels,
    hasLabels
      ? (JSON.parse(encodedLabels) as string[])
          .map(encodedLabelToUri)
          .map((link, index) => labelUriToStepLink(link, index, labelType))
      : [],
  ]
}
